const Auth = {

    addAuthHeader: function(xmlhttp) {
        let token = this.getCookie('accessToken');
        if (token) {
            xmlhttp.setRequestHeader('Authorization', `${token}`);
        }

    },

    getCookie: function(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    
    getFullUrl: function(path) {
        let base = window.baseApiUrl || '';
        return `${base}${path}`;
    }
}

exports.Auth = Auth;